








































































































































import { Component, Vue, Prop, Watch, Ref } from 'vue-property-decorator'
import _ from 'lodash'
import A from '@/utilities/alpha'
import {
  getFrequencyWords,
  processTextJson
} from '@/utilities/text-response-helpers.js'
import $ from 'jquery'
import icoLookup from '@/utilities/ico-lookup'
import InsightActions from './InsightActions.vue'
import TextResponses from '@/components/TextResponses.vue'
import Redactor from '@/components/Redactor.vue'
import { Button, Card } from '@alpha/ink'
import LoggerNote from './LoggerNote.vue'
import * as ui from '@/types/frontend'
import * as db from '@shared/types/database'
import videojs, { VideoJsPlayer } from 'video.js'
import store from '@/store'
import api, { getApiUrl } from '@/api'
import T_SW from '@/utilities/viz-tsw.js'
import analytics from '@/analytics'

const TSW = new T_SW()

@Component({
  components: {
    InsightActions,
    TextResponses,
    LoggerNote,
    Redactor,
    Button,
    Card
  }
})
export default class InsightViewer extends Vue {
  @Prop({ required: true }) workspaceId!: string
  @Prop({ required: true }) testId!: string
  @Prop({ required: true }) activeInsight!: ui.DynamicAsset | ui.DynamicQualAsset
  @Prop({ required: true }) activeInsightIndex!: number
  @Prop({ required: true }) allInsights!: ui.DynamicAsset[]
  @Prop({ required: true }) qualInsightCount!: number
  @Prop({ required: true }) qualNotable!: db.QualNotable[]
  @Ref('insightActions') readonly insightActions!: InsightActions

  wistiaURL: string | null = null
  dataLoaded: boolean = false
  json: ui.DynamicAsset | null = null
  filteredJson: ui.FilteredDynamicAsset | null = null
  player: VideoJsPlayer | null = null
  videoReady: boolean = false
  editable: boolean = true
  activeClientAnalysis: string = this.activeInsight.analysis || ''
  charts = this.getClonedCharts()
  title = this.activeInsight.title
  url = this.activeInsight.url
  savedFilterIndex: number = -1
  originalTotalResponses: number = 0
  currentFilter: ui.TextFilter = {
    keywords: [],
    logicOperator: 'OR',
    totalResponses: 0,
    isRadioButton: null
  }

  activeSlice: string | false = false
  savingNewFilter: boolean = false
  topTerms: ui.Term[] = []
  loadingTextData: boolean = false
  checkedIndex: number = -1

  get edited () {
    let edited = false
    // checks if title has been changed
    if (this.title !== this.activeInsight.title.trim()) {
      edited = true
    }

    // check if slice analysis was changed
    if (this.currentAnalysisKey && this.charts[this.currentAnalysisKey]) {
      if (this.stripHTML(this.activeClientAnalysis) !== this.stripHTML(this.charts[this.currentAnalysisKey].analysis || '')) {
        edited = true
      }
    }

    // check if orignal was changed
    if (!this.currentAnalysisKey) {
      if (this.stripHTML(this.activeClientAnalysis) !== this.stripHTML(this.activeInsight.analysis || '')) {
        edited = true
      }
    }

    return edited
  }

  set edited (value) {
    this.title = this.activeInsight.title.trim()
    if (this.currentAnalysisKey && this.charts[this.currentAnalysisKey]) {
      this.activeClientAnalysis = this.charts[this.currentAnalysisKey].analysis || ''
    }
    if (!this.currentAnalysisKey) {
      this.activeClientAnalysis = this.activeInsight.analysis || ''
    }
  }

  get alphaAnalysis () {
    return this.activeInsight.alphaAnalysis
  }

  get activeAnalysis () {
    if (this.currentAnalysisKey && this.charts[this.currentAnalysisKey].alphaAnalysis !== undefined) {
      return this.charts[this.currentAnalysisKey].alphaAnalysis
    } else {
      return this.alphaAnalysis
    }
  }

  get currentAnalysisKey () {
    const keys = Object.keys(this.charts)
    let analysisKey = keys.find((sliceTitle) => {
      if (!this.activeSlice) return false
      return this.charts[sliceTitle].title.includes(this.activeSlice)
    })
    if (!analysisKey) {
      analysisKey = keys.find((sliceTitle) => sliceTitle.includes(this.activeSlice as string))
    }
    analysisKey = (analysisKey === 'original') ? undefined : analysisKey
    return analysisKey
  }

  get filteredResponses () {
    let returnData

    if (!this.json) {
      console.error('No data available to show responses')
      return false
    }

    if (this.savedFilterIndex >= 0 && this.json.filters && this.savedFilterIndex < this.json.filters.length) {
      returnData = this.json.filters[this.savedFilterIndex]
      // fetch a new batch of answers from the current json
      returnData.answers = this.filterResponses(_.cloneDeep(this.json), returnData.keywords, returnData.logicOperator)
    } else if (this.currentFilter.keywords.length === 0) {
      returnData = this.json
    } else {
      this.updateFilteredResponses()
      returnData = this.filteredJson
    }
    returnData = A.clone(returnData)
    if ((this.activeInsight as ui.DynamicQualAsset).dynamicQual) {
      returnData!.title = ((this.activeInsight as ui.DynamicQualAsset).questionNumber + 1) + '. ' + returnData!.title
    }
    return returnData
  }

  get icoLookup () {
    return icoLookup
  }

  get showToucanFilter () {
    return this.dataLoaded && this.realDataType() === 'text' && !(this.activeInsight as ui.DynamicQualAsset).dynamicQual
  }

  get loggerNotes () {
    const notes = this.activeInsight.logger_notes || this.activeInsight.loggerNotes
    if (!notes) return []
    return A.isJsonString(notes) ? JSON.parse(notes as string) : notes
  }

  openInsightImage () {
    window.open(this.activeInsight.url)
  }

  get isQualNotable () {
    if (!(this.activeInsight as ui.DynamicQualAsset).dynamicQual) {
      return false
    }
    const isNotable = this.qualNotable.findIndex((notable) => {
      return notable.questionNumber === (this.activeInsight as ui.DynamicQualAsset).questionNumber && notable.questionText === this.activeInsight.title
    }) !== -1
    return isNotable
  }

  @Watch('activeInsight')
  changeInsight () {
    this.dataLoaded = false
    this.json = null
    this.charts = this.getClonedCharts()
    if (this.player) {
      this.player.pause()
    }
    this.prepareInsight()
    this.activeClientAnalysis = this.activeInsight.analysis || ''
  }

  @Watch('currentAnalysisKey')
  updateActiveClientAnalysis () {
    if (this.currentAnalysisKey && this.charts[this.currentAnalysisKey]) { // chart exists
      this.activeClientAnalysis = this.charts[this.currentAnalysisKey].analysis || ''
    } else {
      this.activeClientAnalysis = this.activeInsight.analysis || ''
    }
  }

  mounted () {
    const that = this
    $(document).on('keyup.activeInsight', function (e) {
      switch (e.which) {
        case 27: // esc
          that.emitCancel()
          break
        case 37: // left
          that.emitPrev()
          break
        case 39: // right
          that.emitNext()
          break
        default:
      }
    })
  }

  created () {
    this.prepareInsight()
    window.addEventListener('beforeunload', this.preventUnload)
  }

  hasFeature (arg: string) {
    return store.getters.feature.hasFeature(arg)
  }

  preventUnload (event: BeforeUnloadEvent) {
    // https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onbeforeunload
    if (this.edited) {
      // Triggers the confirm alert if editmode or new prototypes not saved
      event.preventDefault()
      event.returnValue = ''
    }
  }

  getClonedCharts () {
    const { charts, textResponses } = this.activeInsight
    if (charts) {
      return A.clone(charts)
    } else if (textResponses) {
      return A.clone(textResponses)
    } else {
      return {}
    }
  }

  updateType (obj: db.SubAsset) {
    this.activeInsight.asset_type = obj.asset_type ? obj.asset_type : ''
    this.activeInsight.url = obj.url
  }

  stripHTML (value: string) {
    return A.stripHTML(value)
  }

  realDataType () {
    const actual = this.activeInsight
    const assetType = actual.asset_type
    if (assetType === '') {
      return 'image'
    } else if (assetType === 'viz') {
      return 'viz'
    } else if (assetType === 'viz-slice') {
      return 'viz-slice'
    } else if (assetType === 'aud-slice') {
      return 'aud-slice'
    } else if (assetType === 'data') {
      return 'data'
    } else if (assetType === 'textResponses') {
      return 'text'
    } else if (assetType === 'text-slice') {
      return 'text'
    } else if (assetType === 'textFrequency') {
      return 'term-count'
    } else if (assetType === 'audio') {
      return 'audio'
    } else if (assetType === 'video' || actual.url.indexOf('alpha-ux.wistia.com') !== -1) {
      return 'video'
    } else {
      return 'iframe'
    }
  }

  updateFilteredResponses () {
    if (!this.json) {
      console.error('No JSON found')
      return
    }
    // this.$set(this, 'filteredJson', _.cloneDeep(this.json))
    this.filteredJson = _.cloneDeep(this.json)
    // don't save filters. this leads to nested data that we don't want...
    if (this.filteredJson.filters) this.$delete(this.filteredJson, 'filters')

    this.filteredJson.answers = this.filterResponses(_.cloneDeep(this.json), this.currentFilter.keywords, this.currentFilter.logicOperator)
    // this.$set(this, 'filteredJson.answers', this.filterResponses(_.cloneDeep(this.json), this.currentFilter.keywords, this.currentFilter.logicOperator))

    this.currentFilter.totalResponses = this.getTotalResponses(this.filteredJson.answers)
    // this.$set(this, 'currentFilter.totalResponses', this.getTotalResponses(this.filteredJson.answers))
    this.setFilterType()
  }

  filterResponses (responses: ui.DynamicAsset, wordsList: string[], logic: ui.LogicOperator) {
    if (_.isEmpty(responses) || wordsList.length === 0) return responses.answers
    return this.filterAnswers(responses.answers, wordsList, logic)
  }

  filterAnswers (answers: ui.DynamicAnswer[] | undefined, wordsList: string[], logic: ui.LogicOperator) {
    if (!answers || answers.length === 0 || wordsList.length === 0) return answers

    if (answers[0].type === 'answer') {
      return _.filter(answers, function (obj) {
        let matches: any[] = []
        // Builds a regex that searches for the wordsList
        const regexMatch = new RegExp(wordsList.map(w => '\\b' + w + '(?![a-z\'`])').join('|'), 'gi')
        // Replace left and right single quotation marks with the straight quotation mark
        const cleanedContent = obj.content.replace(/[\u2018\u2019]/g, "'")
        matches = cleanedContent.match(regexMatch) || matches
        // We remove stop words from our top terms, in order to search by those top terms
        // we're going to remove the stop words from the text and search that as well
        if (matches.length === 0) {
          const cleanedContentWithoutStopwords = TSW.clean(cleanedContent)
          matches = cleanedContentWithoutStopwords.match(regexMatch) || matches
        }

        if (logic === 'AND' && _.uniq(matches).length === wordsList.length) return true
        if (logic === 'OR' && matches.length > 0) return true
        if (logic === 'NOT' && matches.length === 0) return true
        return false
      })
    } else {
      return _.forEach(answers, (value, key, obj) => {
        obj[key].children = this.filterAnswers(obj[key].children, wordsList, logic)
      })
    }
  }

  updateURL (obj: db.SubAsset) {
    this.url = obj.url
    if (obj.slice) this.activeSlice = obj.title
    if (obj.asset_type) this.updateType(obj)
    if (this.realDataType() === 'text') this.getTextResponseData(true)
  }

  emitPrev () {
    this.$emit('selectPrev')
  }

  emitNext () {
    this.$emit('selectNext')
  }

  emitCancel () {
    this.$emit('cancel')
  }

  toggleStarred () {
    const nextStatus = !this.activeInsight.isHighlighted
    this.$emit('updateInsight', { isHighlighted: nextStatus })
    analytics.track('Highlighted Insight', {
      testId: this.testId,
      toggledOn: nextStatus,
      insightId: this.activeInsight.id,
      insightType: this.activeInsight.asset_type
    })
  }

  getWistiaURL (params = []) {
    const assetSrc = this.activeInsight.url.split('/').slice(-1)[0]
    let pString = ''
    // setup wistia url with chapters
    for (const key in params) {
      if ({}.hasOwnProperty.call(params, key)) {
        pString += 'plugin%5Bchapters%5D%5B' + key + '%5D=' + params[key] + '&'
      }
    }
    if (params.length === 0) {
      this.wistiaURL = '//fast.wistia.net/embed/iframe/' + assetSrc
    } else {
      this.wistiaURL = '//fast.wistia.net/embed/iframe/' + assetSrc + '?' + pString
    }
  }

  relativeURL (url: string) {
    const apiUrl = getApiUrl('/api')
    if (window.location.host.indexOf('localhost') !== -1) {
      url = url.replace('https://platform.alphahq.com', apiUrl)
    } else if (window.location.host.indexOf('reef-ui.herokuapp.com') === -1) { // otherwise it's a staging site, and we require HTTPS
      url = url.replace('https://reef-ui.herokuapp.com', apiUrl) // TODO Yair: this shouldn't be hardcoded in like this
    }
    return url
  }

  getTextResponseData (sameAsset?: boolean) {
    this.loadingTextData = true
    // qual responses for a question are generated dynamically
    if ((this.activeInsight as ui.DynamicQualAsset).dynamicQual) {
      this.json = this.activeInsight
      this.topTerms = getFrequencyWords(this.json)
      this.originalTotalResponses = this.getTotalResponses(this.json.answers)
      this.dataLoaded = true
      return
    }
    // Get JSON data for text responses. Better than using an iframe, and we can turn it into a CSV.
    let textURL = this.activeInsight.url
    if (this.activeInsight.asset_type === 'text-slice') {
      const textResponseURLs: string[] = []
      const sliceKeys: string[] = []
      _.forEach(this.activeInsight.textResponses, function (t, k) {
        textResponseURLs.push(t.url)
        sliceKeys.push(k)
      })
      if (_.includes(textResponseURLs, this.url)) {
        textURL = this.url
        this.activeSlice = sliceKeys[textResponseURLs.indexOf(this.url)]
      } else {
        if (sliceKeys.includes('original')) {
          this.activeSlice = 'original'
        } else {
          this.activeSlice = sliceKeys[0]
        }
        textURL = (this.activeInsight.textResponses as Record<string, db.SubAsset>)[this.activeSlice].url
      }
    }
    if (!sameAsset) this.currentFilter.keywords.splice(0, this.currentFilter.keywords.length)

    // workaround for avoiding CORS errors on localhost
    textURL = this.relativeURL(textURL)
    this.url = textURL
    api.getTextAsset(textURL)
      .then(({ data }) => {
        // if json is already well formed, use that, otherwise, process old format into new format
        const filters = (this.json && this.json.filters) ? this.json.filters : false
        this.json = data.answers ? data : processTextJson(data)
        this.topTerms = getFrequencyWords(this.json)
        this.originalTotalResponses = this.getTotalResponses((this.json as ui.DynamicAsset).answers)
        this.dataLoaded = true
        // to ensure that the spinner keeps spinning till we make changes on the DOM
        this.$nextTick(() => {
          this.loadingTextData = false
        })
        if (filters) (this.json as ui.DynamicAsset).filters = filters
      }).catch((err) => {
        console.error('Something went wrong getting asset:', this.url, err)
        this.$nextTick(() => {
          this.loadingTextData = false
        })
      })
  }

  setupAudio () {
    // After DOM is flushed, set up audio player
    this.$nextTick(() => {
      // If we've already initialized one player, just re-use it and reset the source
      if (this.player) {
        this.player.src({
          type: 'audio/x-m4a',
          src: this.activeInsight.url
        })
      } else {
        // Otherwise, initialize player and return a reference
        this.player = videojs(this.$refs.audioPlayer, {
          poster: '/img/audioPoster.jpg',
          controls: true,
          autoplay: false,
          preload: 'auto',
          width: 100,
          height: 400,
          techOrder: ['html5', 'flash', 'aurora']
        }, () => {
          this.videoReady = true
        })
      }
    })
  }

  prepareInsight () {
    if (this.activeInsight.asset_type === 'video' || (this.activeInsight.url && this.activeInsight.url.indexOf('alpha-ux.wistia.com') !== -1)) {
      this.getWistiaURL()
    }
    if (_.includes(['textResponses', 'textFrequency', 'text-slice'], this.activeInsight.asset_type)) {
      if (this.activeInsight.textResponses) {
        const firstKey = Object.keys(this.activeInsight.textResponses)[0]
        const sliceObj = this.activeInsight.textResponses[firstKey]
        this.updateURL(sliceObj)
      } else {
        this.getTextResponseData()
      }
    }
    if (this.activeInsight.asset_type === 'audio') {
      this.setupAudio()
    }
    if (this.activeInsight.asset_type === 'viz-slice') {
      let firstKey
      if (this.activeInsight.charts) {
        firstKey = Object.keys(this.activeInsight.charts)[0]
        this.url = this.activeInsight.charts[firstKey].url
      // text response objects can have different types in each slice. text responses and charts
      // reset it back to the first slice which should be a text response
      } else if (this.activeInsight.textResponses) {
        firstKey = Object.keys(this.activeInsight.textResponses)[0]
        const sliceObj = this.activeInsight.textResponses[firstKey]
        this.updateURL(sliceObj)
      }
    }
    if (this.activeInsight.asset_type === 'aud-slice') {
      const keys = Object.keys(this.activeInsight.charts as Record<string, db.Chart>)
      this.url = (this.activeInsight.charts as Record<string, db.Chart>)[keys[0]].url
    }
    this.editable = !(this.activeInsight as ui.DynamicQualAsset).dynamicQual
    this.title = this.activeInsight.title
  }

  editTitle (content: string) {
    this.$set(this, 'title', content.trim())
  }

  // clientAnalysis is a attribute on the slice or asset that can be editted by client
  setClientAnalysis (content: string) {
    this.activeClientAnalysis = content
  }

  revertChanges () {
    this.title = this.activeInsight.title
    this.charts = this.getClonedCharts()
    if (this.currentAnalysisKey && this.charts[this.currentAnalysisKey]) { // chart exists
      this.activeClientAnalysis = this.charts[this.currentAnalysisKey].analysis || ''
    } else {
      this.activeClientAnalysis = this.activeInsight.analysis || ''
    }
  }

  updateInsight (assetIdx: number, slice: string, clientAnalysis: string) {
    const mutations: ui.Mutations = {
      assetIdx: assetIdx,
      title: this.title
    }

    if (slice && this.allInsights[assetIdx].charts) {
      mutations.charts = {}
      mutations.charts[slice] = { analysis: clientAnalysis }
    } else if (slice && this.allInsights[assetIdx].textResponses) {
      mutations.textResponses = {}
      mutations.textResponses[slice] = { analysis: clientAnalysis }
    } else {
      mutations.analysis = clientAnalysis
    }

    this.$emit('updateInsight', mutations)

    this.edited = false
    this.$nextTick(() => {
      this.activeSlice = 'original'
    })
  }

  selectInsight (idx: number) {
    this.$emit('selectInsight', idx)
  }

  // Toucan filter methods
  generatedS3Key () {
    let text = ''
    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

    for (let i = 0; i <= 20; i++) { text += possible.charAt(Math.floor(Math.random() * possible.length)) }

    return text
  }

  getOldS3Key (url: string) {
    const pointerString = '/staticassets/text/'
    const pointerIndex = url.indexOf(pointerString)
    let key = null
    if (pointerIndex !== -1) {
      key = url.slice(pointerIndex + pointerString.length)
    }

    if (!key) {
      const uriSeg = url.split('/')
      if (uriSeg.length) {
        const hash = uriSeg[uriSeg.length - 1].replace('_text_responses.json', '')
        key = hash.length === 20 ? hash : null
      }
    }

    return key
  }

  toggleSavedFilter (): void {
    if (!this.json || !this.json.filters) {
      console.error('No filters to save')
    } else {
      this.savedFilterIndex = this.json.filters.length - 1
    }
  }

  toggleNextFilter () {
    if (!this.json || !this.json.filters) {
      console.error('No filters to toggle')
    } else {
      if (this.savedFilterIndex === -1) this.savedFilterIndex = 0
      else if (this.savedFilterIndex === this.json.filters.length - 1) this.toggleOriginalFilter()
      else this.savedFilterIndex += 1
    }
  }

  selectFilter (index: number) {
    if (index === -1) {
      this.toggleOriginalFilter()
    } else {
      this.savedFilterIndex = index

      // set current filter
      if (this.json?.filters) {
        const newlySelectedSavedFilter = this.json.filters[index]
        this.currentFilter = {
          isRadioButton: true,
          keywords: newlySelectedSavedFilter.keywords,
          logicOperator: newlySelectedSavedFilter.logicOperator,
          totalResponses: newlySelectedSavedFilter.totalResponses
        }
      }
    }
  }

  toggleOriginalFilter () {
    this.currentFilter = {
      name: 'Original',
      keywords: [],
      logicOperator: 'OR',
      totalResponses: 0
    }
    this.savedFilterIndex = -1
  }

  setFilterType () {
    if (this.filteredJson) {
      this.filteredJson.type = 'filter'
      this.filteredJson.logicOperator = this.currentFilter.logicOperator
      this.filteredJson.totalResponses = this.currentFilter.totalResponses
      this.filteredJson.originalTotalResponses = this.originalTotalResponses
    }
  }

  saveNewFilter (mode: ui.FilterMode, index: number | null = null) {
    const textResponses = this.activeInsight.textResponses
    let filteredJsonClone: ui.FilteredDynamicAsset
    if (mode === 'save') {
      if (!this.filteredJson || !this.json) {
        console.error('No filters to save')
        return
      }
      this.filteredJson.type = 'filter'
      this.filteredJson.totalResponses = this.currentFilter.totalResponses
      this.filteredJson.keywords = this.currentFilter.keywords
      this.filteredJson.logicOperator = this.currentFilter.logicOperator
      this.filteredJson.originalTotalResponses = this.originalTotalResponses

      filteredJsonClone = A.clone(this.filteredJson)

      if (this.json.filters) this.json.filters.push(A.clone(this.filteredJson as any))
      else this.$set(this.json, 'filters', [A.clone(this.filteredJson)])

      analytics.track('Text Filter Saved', {
        testId: this.testId,
        insightId: this.activeInsight.id
      })

      // for filters, we don't need to store all the answers with each filter
      delete filteredJsonClone.answers
    } else if (mode === 'delete') {
      if (!this.json || !this.json.filters || index === null) {
        console.error('No filters to delete')
        return
      }

      this.json.filters.splice(index, 1)
      this.toggleOriginalFilter()
    }

    if (textResponses) {
      const slicePromises: Promise<ui.Slice>[] = []

      _.forEach(textResponses, (slice, sliceKey) => {
        if (slice.asset_type === 'viz-slice') {
          const value: ui.Slice = {
            url: slice.url,
            sliceKey: sliceKey
          }
          slicePromises.push(Promise.resolve(value))
          return
        }
        const assetKey = this.generatedS3Key()
        const oldS3Key = this.getOldS3Key(slice.url)
        if (!oldS3Key) {
          console.log(slice.url, 'failed slice url')
          return
        }

        const sliceUrl = api.getTextResponse(oldS3Key)
          .then((data) => {
            if (mode === 'save') {
              if (data.filters) data.filters.push(filteredJsonClone)
              else data.filters = [filteredJsonClone]
            } else if (mode === 'delete') {
              data.filters = _.cloneDeep((this.json as ui.DynamicAsset).filters)
            }
            return api.updateTextResponse(assetKey, JSON.stringify(data))
          })
          .then(() => {
            return {
              url: 'https://platform.alphahq.com/staticassets/text/' + assetKey,
              sliceKey: sliceKey
            }
          })

        slicePromises.push(sliceUrl)

        Promise.all(slicePromises)
          .then((data) => {
            const updatedURLs = _.cloneDeep(this.activeInsight.textResponses)
            const assetid = this.activeInsight.id

            data.forEach(function (slice) {
              (updatedURLs as Record<string, db.SubAsset>)[slice.sliceKey].url = slice.url
            })

            api.updateAssetUrl(JSON.stringify(updatedURLs), {
              workspaceId: this.workspaceId,
              testId: this.testId,
              assetId: assetid
            })
              .then((res) => {
                this.updateAssetURL(mode, undefined, data)
              })
          })
      })
    } else {
      // for older text responses
      const key = this.generatedS3Key()
      const url = '/staticassets/text/' + key
      const assetid = this.activeInsight.id

      // upload a new updated text response

      const updatePromise = api.updateTextResponse(key, JSON.stringify(this.json))

      const updateUrlPromise = api.updateAssetUrl(JSON.stringify({ url }), {
        workspaceId: this.workspaceId,
        testId: this.testId,
        assetId: assetid
      })

      Promise.all([updatePromise, updateUrlPromise])
        .then(() => {
          this.updateAssetURL(mode, url)
        })
    }
  }

  updateAssetURL (mode: ui.FilterMode, url?: string, textResponseURLs?: ui.Slice[]) {
    this.savingNewFilter = false
    if (textResponseURLs) {
      _.forEach(textResponseURLs, (slice) => {
        (this.activeInsight.textResponses as Record<string, db.SubAsset>)[slice.sliceKey].url = slice.url
      })
    } else if (url) {
      this.activeInsight.url = url
    }
    // Show the saved filter
    if (mode === 'save') {
      this.toggleSavedFilter()
    } else if (mode === 'delete') {
      this.toggleOriginalFilter()
    }
  }

  getTotalResponses (answers: ui.DynamicAnswer[] | undefined) {
    if (!answers || answers.length === 0) return 0
    if (answers[0].type === 'answer') return answers.length
    let total = 0
    answers.forEach(ans => {
      total += this.getTotalResponses(ans.children)
    })
    return total
  }

  selectFilterCheckbox (keyword: string) {
    if (this.currentFilter.isRadioButton) {
      this.updateFilteredResponses()

      this.currentFilter = {
        isRadioButton: false,
        keywords: [keyword],
        totalResponses: this.getTotalResponses(this.filteredJson?.answers),
        logicOperator: 'AND'
      }
    } else {
      this.currentFilter.keywords.push(keyword)
    }

    this.savedFilterIndex = -1
  }

  updateToucan (event: Event & { data: any, index: number }) {
    switch (event.type) {
      case 'addKeyword':
        this.selectFilterCheckbox(event.data)
        break
      case 'deleteKeyword':
        this.currentFilter.keywords.splice(event.data, 1)
        break
      case 'clearAll':
        this.toggleOriginalFilter()
        break
      case 'updateLogic':
        this.currentFilter.logicOperator = event.data
        break
      case 'updateTotalResponses':
        this.currentFilter.totalResponses = event.data
        break
      case 'selectFilter':
        this.selectFilter(event.index)
        break
      case 'toggleOriginalFilter':
        this.toggleOriginalFilter()
        break
      case 'saveFilter':
        this.savingNewFilter = true
        this.saveNewFilter('save')
        break
      case 'deleteSavedFilter':
        this.saveNewFilter('delete', event.index)
        break
    }
  }

  updateQualNotable (insight: ui.DynamicAsset | ui.DynamicQualAsset) { // TODO:COLLIN revisit once insight actions is migrated
    this.$emit('updateQualNotable', insight)
  }

  backInsight () {
    this.$emit('backInsight')
  }
}
